import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDj7nkvENf3E8vTP3dAkEP6xeVZK8QuH5w",
  authDomain: "dddyor.firebaseapp.com",
  projectId: "dddyor",
  storageBucket: "dddyor.appspot.com",
  messagingSenderId: "174313875841",
  appId: "1:174313875841:web:ea729e20a1912ee9d26080",
  measurementId: "G-NBERBBNPZV"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
